import get from 'lodash/get';
import * as types from '../actionTypes/AddressActionTypes';

function AddressReducer(state = {}, action = {}) {
    // NOSONAR
    switch (action.type) {
        case types.GET_ADDRESSES:
        case types.POST_ADDRESSES:
        case types.UPDATE_ADDRESSES:
        case types.SET_DEFAULT_ADDRESS:
        case types.DELETE_ADDRESSES_LOADING: {
            const isLoading = true;
            const isSuccess = false;
            const requestFrom = null;
            return { ...state, isLoading, isSuccess, requestFrom, error: {} };
        }
        case types.GET_ADDRESSES_SUCCESS: {
            const { isLoading, data, defaultAddress, isSuccess } = action.payload;
            return { isLoading, data, isSuccess, defaultAddress };
        }
        case types.GET_ADDRESSES_ERROR: {
            const { isLoading, isSuccess, error } = action.payload;
            return { ...state, isLoading, isSuccess, error };
        }
        case types.POST_ADDRESSES_SUCCESS: {
            const { isLoading, response, isSuccess, requestFrom } = action.payload;
            const newState = { ...state, isSuccess, isLoading, requestFrom };
            if (response.expressCheckout) {
                const expAddress = newState.data.find((address) => address.expressCheckout);
                if (expAddress) {
                    expAddress.expressCheckout = false;
                }
            }
            newState.data.push(response);
            if (response.isDefault) {
                newState.defaultAddress = response;
            }
            return newState;
        }
        case types.POST_ADDRESSES_ERROR:
        case types.UPDATE_ADDRESSES_ERROR: {
            const { isLoading, isSuccess, requestFrom, error } = action.payload;
            return { ...state, isSuccess, isLoading, requestFrom, error };
        }
        case types.UPDATE_ADDRESSES_SUCCESS: {
            const { isLoading, response, isSuccess, requestFrom } = action.payload;
            const newState = { ...state, isSuccess, isLoading, requestFrom };
            if (get(response, 'params.isDefault')) {
                newState.defaultAddress = response.params;
            }
            newState.data = newState.data.map((address) => {
                if (address.id === response.addressId) {
                    if (requestFrom === 'PATCH_FOR_DEFAULT_ADDRESS') {
                        newState.defaultAddress = { ...address, expressCheckout: true };
                        return newState.defaultAddress;
                    }
                    return response.params;
                }
                if (get(response, 'params.expressCheckout') && address.expressCheckout) {
                    return { ...address, expressCheckout: false };
                }
                return address;
            });
            return newState;
        }
        case types.DELETE_ADDRESSES: {
            const isLoading = true;
            const isSuccess = false;
            const requestFrom = null;
            const creditCards = [];
            return { ...state, isLoading, isSuccess, requestFrom, creditCards };
        }
        case types.DELETE_ADDRESSES_CREATE_SUCCESS:
        case types.DELETE_ADDRESSES_SUCCESS: {
            const { isLoading, deleteId, isSuccess, requestFrom } = action.payload;
            const creditCards = [];
            const newState = { ...state, isSuccess, isLoading, requestFrom, creditCards };
            newState.data = newState.data.filter((address) => address.id !== deleteId);
            return newState;
        }
        case types.DELETE_ADDRESSES_ERROR: {
            return { ...state, ...action.payload };
        }
        case types.CLEAN_REQUEST_ADDRESSES: {
            const requestFrom = null;
            return { ...state, requestFrom };
        }
        case types.HIDE_ADDRESS: {
            const showAddress = false;
            return { ...state, showAddress };
        }
        default:
            return state;
    }
}

AddressReducer.reducerName = 'addressDetails';
export default AddressReducer;
